import { Component } from '@angular/core';
import { AngularFirestore, QueryFn } from '@angular/fire/compat/firestore';
import { isThisQuarter } from 'date-fns';
import { collection, getDocs, writeBatch, doc, Firestore, query, where } from 'firebase/firestore';
import { firstValueFrom, tap } from 'rxjs';
export interface Tile {
  color: string;
  cols: number;
  rows: number;
  text: string;
}
@Component({
  selector: 'app-test',
  templateUrl: './test.component.html',
  styleUrls: ['./test.component.scss']
})
export class TestComponent {

  priority_agency = [
    {
      "Agency Name": "Bureau of Internal Revenue",
      "Agency ID": "SW2cCH47vn2iRaM5cs5m"
    },
    {
      "Agency Name": "Land Transportation Office",
      "Agency ID": "shPrQLQhhqec333Zfj1E"
    },
    {
      "Agency Name": "Philippine Health Insurance Corporation",
      "Agency ID": "g6EkAvqbPI2CUQe5wNAf"
    },
    {
      "Agency Name": "Home Development Mutual Fund",
      "Agency ID": "ZpEjdOr7YooG5R3sbe4v"
    },
    {
      "Agency Name": "Lung Center of the Philippines",
      "Agency ID": "BaxrHHN1c5DJLylRVl0a"
    },
    {
      "Agency Name": "East Avenue Medical Center",
      "Agency ID": "0K55YlbJRBqa1hqAWc3j"
    },
    {
      "Agency Name": "University of the Philippines",
      "Agency ID": "RYKSujhkOwudIaevSNc0"
    },
    {
      "Agency Name": "Polytechnic University of the Philippines",
      "Agency ID": "GTzLe79ERFifqDppk5Hk"
    },
    {
      "Agency Name": "Calamba Water District",
      "Agency ID": "Hin7fQ3bdHGlkzRdvVjf"
    },
    {
      "Agency Name": "Bustos Water District",
      "Agency ID": "oYkKIKgf9NYHCjz8s0FM"
    },
    {
      "Agency Name": "Social Security System",
      "Agency ID": "LPD25GfPC6NIK9x44KIc"
    },
    {
      "Agency Name": "Securities and Exchange Commission",
      "Agency ID": "tsMVGn9RrXfmWEfsiUYL"
    },
    {
      "Agency Name": "Department of Health",
      "Agency ID": "AdxN3RpS0vPtBkNPXZAJ"
    },
    {
      "Agency Name": "Department of Interior and Local Government",
      "Agency ID": "I2sSthBe2rYFg5Jz5q8n"
    },
    {
      "Agency Name": "Philippine Statistics Authority",
      "Agency ID": "jF7sVfIfjhnQRZ1nrxSi"
    },
    {
      "Agency Name": "Food and Drug Administration",
      "Agency ID": "AdxN3RpS0vPtBkNPXZAJ"
    },
    {
      "Agency Name": "Department of Trade and Industry",
      "Agency ID": "BetEzqWsbeDo90SZDwgj"
    },
    {
      "Agency Name": "Department of Information and Communications Technology",
      "Agency ID": "2vfLSkXMqYOocILF6l9O"
    },
    {
      "Agency Name": "Department of Energy",
      "Agency ID": "X6Dfr0NtchgDBrqGZIju"
    },
    {
      "Agency Name": "Government Service Insurance System",
      "Agency ID": "m5mSfFCcJILuP3b12HZz"
    },
    {
      "Agency Name": "Department of Public Works and Highways",
      "Agency ID": "3LD0xmtvT0GvhPe1k2LS"
    },
    {
      "Agency Name": "Department of Transportation",
      "Agency ID": "U8NrcG4honQNhwgxKvtx"
    },
    {
      "Agency Name": "Land Transportation and Franchising Board",
      "Agency ID": "wqMPqMi2wpu5gegM0BkO"
    },
    {
      "Agency Name": "Philippine Economic Zone Authority",
      "Agency ID": "eUKwFaTTVzWHxuB7GYAV"
    },
    {
      "Agency Name": "Philippine Ports Authority",
      "Agency ID": "Yz5OhVZVmgL0WJinXgRk"
    },
    {
      "Agency Name": "Bureau of Customs",
      "Agency ID": "7lCm5WNS7wwTlweZL8Eh"
    },
    {
      "Agency Name": "Land Registration Authority",
      "Agency ID": "13en95xu3jKUnhYBvES9"
    },
    {
      "Agency Name": "Energy Regulatory Commission",
      "Agency ID": "C9QDVfMNc6T6v0gAzqpW"
    },
    {
      "Agency Name": "Department of Human Settlements and Urban Development",
      "Agency ID": "sakZPcZasve0QdfRqzPP"
    },
    {
      "Agency Name": "National Meat Inspection Service",
      "Agency ID": "4QaW4KTKZm83jlWbdcsn"
    },
    {
      "Agency Name": "National Food Authority",
      "Agency ID": "bQ3kEZ8iZbHbeaIVlsE4"
    },
    {
      "Agency Name": "Fertilizer and Pesticide Authority",
      "Agency ID": "gv9Qn9wrvFCGEU12N34T"
    },
    {
      "Agency Name": "Philippine Crop Insurance Corporation",
      "Agency ID": "Pw5koiXibS6qWPaUqzzn"
    },
    {
      "Agency Name": "Bureau of Animal Industry",
      "Agency ID": "fAwnUQG5whl5IKCiaipc"
    },
    {
      "Agency Name": "Bureau of Plant Industry",
      "Agency ID": "x0RwxUc7lEXigwlYEtbb"
    },
    {
      "Agency Name": "Bureau of Fisheries and Aquatic Resources",
      "Agency ID": "qJVYS0FojCiP9Ekh1Hih"
    },
    {
      "Agency Name": "National Commission on Indigenous Peoples",
      "Agency ID": "0TYoIIrqulhiKlkIp1BT"
    },
    {
      "Agency Name": "Environmental Management Bureau",
      "Agency ID": "g9wZVya2k75trznUugYI"
    },
    {
      "Agency Name": "Philippine Mining Development Corporation",
      "Agency ID": "5LECWU9NTZTlt1AQZPEa"
    },
    {
      "Agency Name": "Land Management Bureau",
      "Agency ID": "Pw5koiXibS6qWPaUqzzn"
    },
    {
      "Agency Name": "Biodiversity Management Bureau",
      "Agency ID": "dbV7m4m1ZXwChipLZCV8"
    },
    {
      "Agency Name": "Natural Resources Development Corporation",
      "Agency ID": "9zHIfv52QxKwiLzcPrHo"
    },
    {
      "Agency Name": "National Mapping and Resource Information Authority",
      "Agency ID": "RTzvBSi12CyCRwU7TEsZ"
    },
    {
      "Agency Name": "Ecosystems Research and Development Bureau",
      "Agency ID": "qJpSpwvJQSPwjGH6y76q"
    },
    {
      "Agency Name": "National Water Resources Board",
      "Agency ID": "GzFB6zTFo5RmZ8IkYaKU"
    },
    {
      "Agency Name": "Civil Aviation Authority of the Philippines",
      "Agency ID": "BetEzqWsbeDo90SZDwgj"
    },
    {
      "Agency Name": "Local Government Unit of Quezon City",
      "Agency ID": "LPD25GfPC6NIK9x44KIc"
    },
    {
      "Agency Name": "Anti-Red Tape Authority",
      "Agency ID": "6LYJMp4Zp8MEvBqek70B"
    },
    {
      "Agency Name": "ARTA_Initial",
      "Agency ID": "awqtdbglaXtyMypgNOOm"
    },
    {
      "Agency Name": "Department of Agriculture",
      "Agency ID": "opXx93eFMdaWnWcGXohl"
    },
    {
      "Agency Name": "Department of Agrarian reform",
      "Agency ID": "cBBwWtvOmS2d1ptOxHhc"
    },
    {
      "Agency Name": "Bureau of Soils and Water Management",
      "Agency ID": "16666cqVTKEtCzJaqOOW"
    },
    {
      "Agency Name": "Department of Environment and Natural Resources",
      "Agency ID": "laBUTK8erohevnxQEUzh"
    },
    {
      "Agency Name": "City Government of Manila",
      "Agency ID": "tCLBHuQSpetMhmLeKGEm"
    }
  ]

  constructor(private afs: AngularFirestore){

  }

   personalSet = new Set(this.priority_agency.map(agency => agency["Agency ID"]));


   agencyselected(event:any){
    const data = event.options[0].value
  
    this.list_cc =[]
    this.list_service = []
    this.loadCitizensCharter(data.id)
   }

   citizensCharterChange(event:any){
    const cc = event.options[0].value
    this.list_service=[]
    this.list_worklist=[]
    this.list_coc=[]
    this.loadservices(cc.id)
    this.loadWorlist(cc.id)
    this.loadCertificateofCompliance(cc.id)

    console.log("Citizens Charter: ",cc)
   }

   deleteCC(cc:any){
    console.log("CC: ",cc)

    const batch = this.afs.firestore.batch();

    this.list_service.forEach((doc:any)=>{
      const docref = this.afs.firestore.collection(this.col_service).doc(doc)

      batch.delete(docref)
    })

    this.list_worklist.forEach((doc:any)=>{
      const docref = this.afs.firestore.collection(this.col_worklist).doc(doc)

      batch.delete(docref)
    })

    this.list_coc.forEach((doc:any)=>{
      const docref = this.afs.firestore.collection(this.col_coc).doc(doc)
      batch.delete(docref)
    })

    
    batch.commit().then(()=>{

    }).catch(e=>{
      console.log("Error deleting")
    })

   }

   serviceChange(event:any){
    this.current_data = event.options[0].value
   }

  tiles: Tile[] = [
    {text: 'One', cols: 3, rows: 1, color: 'lightblue'},
    {text: 'Two', cols: 1, rows: 2, color: 'lightgreen'},
    {text: 'Three', cols: 1, rows: 1, color: 'lightpink'},
    {text: 'Four', cols: 2, rows: 1, color: '#DDBDF1'},
  ];
  

 col_service:any ='Services Phase 02'
 col_citizens_charter='citizens-charter-phase-02'
 col_service_certification='services-certification-phase-02'
 col_agency='Agency'
 col_worklist='Worklist-Citizens Charter'
 col_coc='Certificate of Compliance Submissions'

 list_agency:any=[]
 list_cc:any =[]
 list_service:any =[]
 list_worklist:any =[]
 list_coc:any =[]

 loadAgency(){

  this.list_agency= []

  let colfilter: QueryFn = (ref) =>
    ref.orderBy('agencyDetails.agencyName', 'asc'); // ✅ Use 'ref', not 'filter'

  this.afs.collection(this.col_agency, colfilter)
  .snapshotChanges()
  .pipe(
    tap((data: any) => {

      this.list_agency = data
        .map((info:any)=>{
          let item: any = info.payload.doc.data();
          item.id = info.payload.doc.id;
          return item
        })
        .filter((agency:any)=> this.personalSet.has(agency.id))
    
    })
  )
  .subscribe();
 }

 current_data:any=""

 loadWorlist(cc:any){
  let colfilter: QueryFn = (ref) =>
    ref.where('citizensCharter','==',cc)

  this.afs.collection(this.col_worklist, colfilter)
  .snapshotChanges()
  .pipe(
    tap((data: any) => {

      this.list_worklist = data
        .map((info:any)=>{
          let item: any = info.payload.doc.data();
          item.id = info.payload.doc.id;
          return item
        })
    })

    

  )
  .subscribe();

  

 }

 loadCertificateofCompliance(cc:any){
  let colfilter: QueryFn = (ref) =>
    ref.where('citizensCharter_Id','==',cc)

  this.afs.collection(this.col_coc, colfilter)
  .snapshotChanges()
  .pipe(
    tap((data: any) => {

      this.list_coc = data
        .map((info:any)=>{
          let item: any = info.payload.doc.data();
          item.id = info.payload.doc.id;
          return item
        })
    })
  ).subscribe()


 }
 

  loadservices(cc:any){

    let colfilter: QueryFn = (ref) =>
      ref.where('citizens_charter','==',cc)

    
  this.afs.collection(this.col_service, colfilter)
  .snapshotChanges()
  .pipe(
    tap((data: any) => {

      this.list_service = data
        .map((info:any)=>{
          let item: any = info.payload.doc.data();
          item.id = info.payload.doc.id;
          return item
        })
    })

    

  )
  .subscribe();

    /* const batch = this.afs.firestore.batch();

    service_list.forEach( async (id:any)=>{
     const snapshot = await this.afs.collection(this.col_service).doc(id).get()

   snapshot.forEach((doc:any)=>{
    console.log("Document Service: ",doc)
   })
   
    }) */

   

  }

  loadCitizensCharter(id:any){
    this.list_cc =[]
    let colfilter: QueryFn = (ref) =>
      ref
      .where('fromAgencyId','==',id)
      .orderBy('dateSubmitted','desc')

    this.afs.collection(this.col_citizens_charter,colfilter)
    .snapshotChanges()
    .pipe(
      tap((data:any)=>{
        this.list_cc = data
        .map((info:any)=>{
          let item: any = info.payload.doc.data();
          item.id = info.payload.doc.id;
          return item
        })
      })
    ).subscribe()
  }

  list:any = []

  deletedocs(){
    this.deleteFilteredDocumentsInChunks('Certificate of Compliance Submissions','cocYear',2024,'<=').then(result=>{
      console.log("Completed....")
    })
  }



  async deleteFilteredDocumentsInChunks(collectionName: string, field: string, value: any,operator:any,batchSize = 100): Promise<void> {
    try {
      while (true) {
        const snapshot = await firstValueFrom(
          this.afs.collection(collectionName, ref =>
            ref.where(field, operator, value).limit(batchSize)
          ).get()
        );

        if (snapshot.empty) {
          console.log('No more matching documents to delete.');
          break;
        }

        const batch =this.afs.firestore.batch();
        snapshot.docs.forEach(doc => batch.delete(doc.ref));

        await batch.commit();
        console.log(`Deleted ${snapshot.docs.length} documents in this batch.`);
      }
    } catch (error) {
      console.error('Error deleting documents:', error);
    }
  }

}
